import React, { useEffect, useState } from "react";
import { Card, Table, Row, Col } from "react-bootstrap";
import demoImage from "../../assets/images/patientbed.png";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { FaVial, FaFlask, FaCheckCircle } from "react-icons/fa"; // Icons for stats

const BASE_URL = process.env.REACT_APP_BASE_URL; // Adjust the base URL as needed

const LabDashboard = () => {
  const [stats, setStats] = useState({
    pending: 0,
    collected: 0,
    completed: 0,
  });
  const [recent, setRecent] = useState([]);
    const navigate = useNavigate();

  useEffect(() => {
    // Add an extra entry to browser history
    window.history.pushState(null, "", window.location.href);

    const handleBack = () => {
      window.history.go(1); // prevent back
    };

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/lab/requests`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        const data = res.data || [];

        // Summary counts
        setStats({
          pending: data.filter((r) => r.status === "Pending").length,
          collected: data.filter((r) => r.status === "Sample Collected").length,
          completed: data.filter((r) => r.status === "Completed").length,
        });

        // Today's requests
        const todayStr = new Date().toISOString().slice(0, 10);
        const todayRequests = data.filter(
          (r) => r.requested_at && r.requested_at.slice(0, 10) === todayStr
        );

        setRecent(todayRequests.slice(0, 5));
      } catch (error) {
        console.error("Error fetching lab data:", error);
        setStats({ pending: 0, collected: 0, completed: 0 });
        setRecent([]);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      <div className="flex-grow-1 p-4">
        {/* Header */}
        <Card className="shadow-sm p-3 mb-4">
          <Row className="align-items-center">
            <Col md={8}>
              <h6 className="text-muted">Good Morning,</h6>
              <h2 className="fw-bold text-teal primary-class">Welcome, Lab</h2>
              <p className="text-muted mb-0">
                Your health, your records, your test results – all in one place.
              </p>
            </Col>
            <Col md={4} className="text-center">
               <img
                src={demoImage}
                alt="Dashboard"
                style={{ maxHeight: "120px" }}
                />
            </Col>
          </Row>
        </Card>

        {/* Stats Section */}
        <Row className="mb-4 g-3">
          <Col md={4}>
            <Card className="stat-card shadow-sm h-100">
              <Card.Body className="d-flex align-items-center">
                <div className="vertical-line me-3"></div>
                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-start">
                    <span className="stat-count">{stats.pending}</span>
                    <FaVial className="stat-icon" />
                  </div>
                  <h6 className="mb-0 fw-bold mt-3">Pending Tests</h6>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="stat-card shadow-sm h-100">
              <Card.Body className="d-flex align-items-center">
                <div className="vertical-line me-3"></div>
                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-start">
                    <span className="stat-count">{stats.collected}</span>
                    <FaFlask className="stat-icon" />
                  </div>
                  <h6 className="mb-0 fw-bold mt-3">Sample Collected</h6>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="stat-card shadow-sm h-100">
              <Card.Body className="d-flex align-items-center">
                <div className="vertical-line me-3"></div>
                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-start">
                    <span className="stat-count">{stats.completed}</span>
                    <FaCheckCircle className="stat-icon" />
                  </div>
                  <h6 className="mb-0 fw-bold mt-3">Completed</h6>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Table */}
        <Card className="shadow-sm mb-4">
          <Card.Body>
            <h5 className="fw-bold mb-3 primary-class">{"Today’s Test Requests"}</h5>
            <Table responsive hover>
              <thead className="table-light">
                <tr>
                  <th>Patient</th>
                  <th>Test Type</th>
                  <th>Urgency</th>
                  <th>Status</th>
                  <th>Requested</th>
                </tr>
              </thead>
              <tbody>
                {recent.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center text-danger">
                      No requests today.
                    </td>
                  </tr>
                ) : (
                  recent.map((r) => (
                    <tr key={r.id}>
                      <td>{r.patient_name || "-"}</td>
                      <td>{r.test_type}</td>
                      <td>{r.urgency}</td>
                      <td>
                        <span
                          style={{
                            color:
                              r.status === "Completed"
                                ? "green"
                                : r.status === "Sample Collected"
                                ? "#13bfa6"
                                : "orange",
                            fontWeight: 600,
                          }}
                        >
                          {r.status}
                        </span>
                      </td>
                      <td>
                        {r.requested_at
                          ? new Date(r.requested_at).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default LabDashboard;
